import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { authService } from '../../services/authService';
import Input from '../../components/ui/Input';
import Button from '../../components/ui/Button';
import Icon from '../../components/AppIcon';

const SignIn = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e?.preventDefault();
    setError('');
    setLoading(true);

    try {
      const { data, error: signInError } = await authService?.signIn(email, password);
      
      if (signInError) {
        setError(signInError?.message || 'Failed to sign in');
        setLoading(false);
        return;
      }

      if (data?.user) {
        // Check user role from metadata
        const userRole = data?.user?.user_metadata?.role || 'customer';
        
        // Navigate based on role
        if (userRole === 'admin') {
          navigate('/admin/dashboard');
        } else {
          navigate('/customer/dashboard');
        }
      }
    } catch (err) {
      setError('An unexpected error occurred');
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="flex items-center justify-center mb-4">
            <Icon name="Wrench" size={48} color="var(--color-primary)" />
          </div>
          <h1 className="font-headline font-bold text-3xl md:text-4xl text-foreground mb-2">
            Welcome Back
          </h1>
          <p className="font-body text-muted-foreground">
            Sign in to your meriodine account
          </p>
        </div>

        <div className="bg-card rounded-lg shadow-sm border border-border p-6 md:p-8">
          <form onSubmit={handleSubmit} className="space-y-6">
            <Input
              label="Email Address"
              type="email"
              value={email}
              onChange={(e) => setEmail(e?.target?.value)}
              placeholder="your.email@example.com"
              required
            />

            <Input
              label="Password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e?.target?.value)}
              placeholder="Enter your password"
              required
            />

            <div className="text-right">
              <Link to="/forgot-password" className="font-body text-sm text-primary hover:underline">
                Forgot Password?
              </Link>
            </div>

            {error && (
              <div className="bg-error/10 border border-error text-error rounded-lg p-3 text-sm">
                {error}
              </div>
            )}

            <Button
              type="submit"
              variant="default"
              size="lg"
              loading={loading}
              className="w-full"
            >
              {loading ? 'Signing In...' : 'Sign In'}
            </Button>
          </form>

          <div className="mt-6 text-center">
            <p className="font-body text-sm text-muted-foreground">
              Don't have an account?{' '}
              <Link to="/signup" className="text-primary hover:underline font-medium">
                Sign Up
              </Link>
            </p>
          </div>

          <div className="mt-8 pt-6 border-t border-border">
            <div className="space-y-2 text-xs font-body">
            </div>
          </div>
        </div>

        <div className="mt-6 text-center">
          <Link to="/" className="font-body text-sm text-primary hover:underline">
            ← Back to Home
          </Link>
        </div>
      </div>
    </div>
  );
};

export default SignIn;